import React, { useState, useEffect } from "react";
import { EditionRecord, PrintRecord, BookRecord } from "../../../BlakeData/Types";
import { API } from "../../../BlakeData";

function printURL(print:PrintRecord){
    return `http://www.blakearchive.org/copy/${print.editionID}?descId=${print.descID}`
}

export default function PrintDetails(props: { position?: string, print: PrintRecord }) {

    const [edition, setEdition] = useState<EditionRecord>();
    const [book, setBook] = useState<BookRecord>();

    useEffect(() => {
        API.getEdition(props.print.editionID).then((edition: EditionRecord) => setEdition(edition));
    }, [props.print.editionID]);

    useEffect(() => {
        if (!edition) { return; }
        API.getBook(edition.bookID).then(setBook);
    }, [edition]);

    const positionBlock = props.position ? <span className="position">{props.position}</span> : (null)

    return (

        <div className="PrintDetails">
            <div className="meta-text">
                <span>
                    {positionBlock}<span className="bold">{book ? book.title : (null)}</span>
                </span>
                <span> {edition ? ` Copy ${edition.archiveCopyID},  ${edition.institution}` : (null)}</span>
                {" "}<a href={printURL(props.print)}>View on Blake Archive</a>
            </div>
        </div>

    )
}
